import Layout from '@/layout/index.vue'

export const layoutName = 'Layout'
//系统静态路由
export const systemRoutes = [
  {
    path: '/',
    name: layoutName,
    component: Layout,
    redirect: import.meta.env.VITE_DASHBOARD_URL || '/home',
    children: [
    ],
  },
  {
    path: '/404',
    component: () => import('@/views/error/404.vue'),
  },
  {
    path: '/500',
    component: () => import('@/views/error/404.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error/404.vue'),
  },
]

//auth静态路由
export const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/zuowei',
    name: 'zuowei',
    component: () => import('@/views/hudong/zuowei/index.vue'),
    meta: {
      title: '座位',
    },
  },
  {
    path: '/qiandao',
    name: 'qiandao',
    component: () => import('@/views/hudong/qiandao/index.vue'),
    meta: {
      title: '签到',
    },
  },
  {
    path: '/hudongzhufu',
    name: 'hudongzhufu',
    component: () => import('@/views/hudong/hudongzhufu/index.vue'),
    meta: {
      title: '祝福',
    },
  },
  {
    path: '/jiaoyou',
    name: 'jiaoyou',
    component: () => import('@/views/hudong/jiaoyou/index.vue'),
    meta: {
      title: '交友',
    },
  },
  {
    path: '/choujiang',
    name: 'choujiang',
    component: () => import('@/views/hudong/choujiang/index.vue'),
    meta: {
      title: '抽奖',
    },
  },
  {
    path: '/pingtu',
    name: 'pingtu',
    component: () => import('@/views/hudong/pingtu/index.vue'),
    meta: {
      title: '拼图点到',
    },
  },
  {
    path: '/fenwei',
    name: 'fenwei',
    component: () => import('@/views/hudong/fenwei/index.vue'),
    meta: {
      title: '氛围互动',
    },
  },
  {
    path: '/teibie',
    name: 'teibie',
    component: () => import('@/views/hudong/teibie/index.vue'),
    meta: {
      title: '特别奖励',
    },
  },
  {
    path: '/xianchang',
    name: 'xianchang',
    component: () => import('@/views/hudong/xianchang/index.vue'),
    meta: {
      title: '现场投票',
    },
  },
  {
    path: '/h5',
    name: 'h5',
    component: () => import('@/views/h5/index.vue'),
    meta: {
      title: 'H5',
    },
  },
  {
    path: '/puzzle',
    name: 'puzzle',
    component: () => import('@/views/hudong/puzzle/index.vue'),
    meta: {
      title: '拼图点到',
    },
  },
]
